import React, { useEffect, useRef, useState } from "react";
import Layout from "../../components/Layout";
import { Button, Table } from "react-bootstrap";
import { MdCancel, MdEdit, MdSave } from "react-icons/md";
import { addRules, getRulesByTenant, updateRules } from "../../api/RulesApi";
import ToastFile from "../../utils/ToastFile";

const RulesRegulation = () => {
  const [rules, setRules] = useState({});
  const [value, setValue] = useState("")
  const [isEdit, setIsEdit] = useState(false);
  const fetched = useRef(false);
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    getRules();
  }, []);

  const getRules = async() => {
    await getRulesByTenant(user.tenant_id)
      .then((res) => {
         if (res.status === 200 && res?.data?.data) {
          setRules(res?.data?.data?.rules);
          setValue(res?.data?.data?.rules?.rules)
        }
      })
      .catch((err) => {
        console.error("Error fetching Rules:", err);
        ToastFile("Error fetching Rules", "error");
      });
  };

  const onSubmit = () => {
    setIsEdit(false);
    let payload = {
      rules: value,
      tenant_id: user.tenant_id,
      createdBy: user.user_id,
      createdAt: new Date(),
      modifiedBy: user.user_id,
      modifiedAt: new Date(),
    };
    if (rules?._id) {
      updateRules(rules._id, payload)
        .then((res) => {
          if (res.status === 200) {
            ToastFile("Rules updated successfully", "updated");
          } else {
            ToastFile("Failed to update rules", "error");
          }
        })
        .catch((err) => {
          console.error("Error updating rules:", err);
          ToastFile("Error updating rules", "error");
        });
    } else {
      addRules(payload)
        .then((res) => {
          if (res.status === 201) {
            ToastFile("Rules added successfully", "added");
          } else {
            ToastFile("Failed to add rules", "error");
          }
        })
        .catch((err) => {
          console.error("Error adding rules:", err);
          ToastFile("Error adding rules", "error");
        });
    }
  };

  const convertHtml = (text) => {
    if (!text) return (
      <div style={{height:500, color:"#aaa"}}>Add your rules and regulation here</div>
    );
    const formatted = text.replace(/\\t/g, "&emsp;").replace(/\\n/g, "<br/>");
    return (
      <div style={{ whiteSpace: "pre-wrap", tabSize: 4, minHeight:500 }}>{formatted}</div>
    );
  };

  return (
    <Layout>
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
           <span
            style={{
              fontSize: "22px",
              fontWeight: 600,
              minWidth: "140px",
            }}
          >
            Rules and Regulations
          </span>
        </div>
        {user.role === "contractor" && <div className="d-flex justify-content-end w-100 px-3 p-2">
          {!isEdit ? (
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => setIsEdit(true)}
              className="edit-button"
            >
              <MdEdit className="me-1" />
              Edit
            </Button>
          ) : (
            <div>
              <Button
                variant="success"
                size="sm"
                onClick={()=>onSubmit()}
                className="me-2"
              >
                <MdSave className="me-1" />
                Save
              </Button>
              <Button variant="outline-secondary" size="sm" onClick={() => setIsEdit(false)}>
                <MdCancel className="me-1" />
                Cancel
              </Button>
            </div>
          )}
        </div>}

        <div className="card mb-4">
          <div className="card-body">
            <Table bordered responsive size="sm">
              <tbody>
                <tr style={{minHeight:500}}>
                  <td style={{minHeight:500}}>
                    {isEdit ? (
                      <div>
                        <textarea
                          value={value}
                          style={{ width: "100%", height: 500 }}
                          onChange={(e) => setValue(e.target.value)}
                        />
                      </div>
                    ) : (
                      convertHtml(value)
                    )}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RulesRegulation;